export default __webpack_public_path__ + "static/media/apalpador.881cd832.png";